import { z } from "zod";
import { optionalUuid } from "../lib/zod-helpers";

/**
 * HCA Moravia — validační schémata pro `hca.pozorovani` tRPC router.
 * 5-smajlíková škála per §A.10 — mapuje na skorePercent 100/75/50/25/0.
 */

export const pozorovaniSmajlikEnum = z.enum([
  "SKVELY_100",
  "DOBRY_75",
  "PRUMERNY_50",
  "SLABY_25",
  "NEDOSTATECNY_0",
]);
export type PozorovaniSmajlik = z.infer<typeof pozorovaniSmajlikEnum>;

/** Vytvoření pozorování asistentem. */
export const createPozorovaniSchema = z.object({
  dochazkaId: z.string().uuid("Neplatné ID docházky"),
  smajlik: pozorovaniSmajlikEnum,
  doporuceniText: z.string().max(2000, "Doporučení musí být 2000 znaků nebo méně").optional(),
  doporucProduktId: optionalUuid("Neplatné ID produktu"),
});

/** Update existujícího pozorování. */
export const updatePozorovaniSchema = z.object({
  id: z.string().uuid("Neplatné ID pozorování"),
  smajlik: pozorovaniSmajlikEnum.optional(),
  doporuceniText: z
    .string()
    .max(2000, "Doporučení musí být 2000 znaků nebo méně")
    .nullable()
    .optional(),
  doporucProduktId: z.string().uuid("Neplatné ID produktu").nullable().optional(),
});

/** Non-paginated list per docházka. */
export const listPozorovaniByDochazkaSchema = z.object({
  dochazkaId: z.string().uuid("Neplatné ID docházky"),
});

/** Non-paginated list per termín (joiny na docházku + klient). */
export const listPozorovaniByTerminSchema = z.object({
  terminId: z.string().uuid("Neplatné ID termínu"),
});

/** ID-only schema. */
export const pozorovaniIdSchema = z.object({
  id: z.string().uuid("Neplatné ID pozorování"),
});

export type CreatePozorovaniInput = z.infer<typeof createPozorovaniSchema>;
export type UpdatePozorovaniInput = z.infer<typeof updatePozorovaniSchema>;
export type ListPozorovaniByDochazkaInput = z.infer<typeof listPozorovaniByDochazkaSchema>;
export type ListPozorovaniByTerminInput = z.infer<typeof listPozorovaniByTerminSchema>;
export type PozorovaniIdInput = z.infer<typeof pozorovaniIdSchema>;

/** Mapa smajlík → skorePercent (drží router při create/update). */
export const SMAJLIK_TO_SKORE: Record<PozorovaniSmajlik, number> = {
  SKVELY_100: 100,
  DOBRY_75: 75,
  PRUMERNY_50: 50,
  SLABY_25: 25,
  NEDOSTATECNY_0: 0,
};
